import { Injectable } from '@angular/core';
import { ArcService } from './arc.service';

@Injectable()
export class UsersService {
  users = new Map<string, Object>();
  private _isInitialized = false;

  constructor(
    private arcs: ArcService
  ) { }

  init(obj: Object) {
    Object.keys(obj || {}).forEach(k => this.users.set(k, obj[k]));
  }

  displayName(email) {
    let u = this.users.get(email);
    if (!u) {
      return email;
    }
    return u['displayName'];
  }

  get(email) {
    return this.users.get(email);
  }

  get list() {
    let ls = [];
    this.users.forEach(x => ls.push(x));
    ls.sort((a, b) =>
      a['displayName'].toLowerCase() < b['displayName'].toLowerCase() ? -1 : 1);
    return ls;
  }

  saveUser(email, displayName) {
    let obs = this.arcs.run({
      fun: 'saveUser',
      data: {
        email: email,
        displayName: displayName
      }
    });
    obs.subscribe((resp) => {
      if (resp['isSuccess'])
        this.users.set(email, { email: email, displayName: displayName });
    });
    return obs;
  }

  deleteUser(email) {
    let obs = this.arcs.run({
      fun: 'deleteUser',
      userEmail: email
    });
    obs.subscribe((resp) => {
      if (resp['isSuccess'])
        this.users.delete(email);
    });
    return obs;
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/users.service.ts